var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImgNoReward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3616 23.6929C29.0804 24.021 28.6118 24.1147 28.3306 23.8335L21.6749 18.6251C21.3786 18.7846 21.039 18.875 20.6797 18.875H7.28125C6.14844 18.875 5.25 17.9766 5.25 16.8438V12.625H4.625C4.27344 12.625 4 12.3516 4 12V7C4 6.3604 4.32534 5.78276 4.82966 5.44272L0.307074 1.90354C-0.0209611 1.66925 -0.114685 1.20066 0.166487 0.872644L0.635109 0.263477C0.916282 -0.0176763 1.3849 -0.111394 1.71294 0.169759L6.60154 3.99536C6.58572 3.85571 6.57812 3.71163 6.57812 3.5625C6.57812 1.6875 8.10156 0.125 10.0156 0.125C11.6172 0.125 12.6719 0.984375 14.0391 2.82031C15.3672 0.984375 16.4219 0.125 18.0625 0.125C19.9375 0.125 21.5 1.6875 21.5 3.5625C21.5 4.14844 21.3438 4.65625 21.0703 5.125H22.125C23.1406 5.125 24 5.98438 24 7V12C24 12.3516 23.6875 12.625 23.375 12.625H22.75V16.6324L29.7365 22.0997C30.0177 22.334 30.1114 22.8026 29.8302 23.1306L29.3616 23.6929ZM20.875 15.1651V12.625H17.6291L20.875 15.1651ZM16.5 11.7414V10.75H22.125V7H14.9375V10.5187L16.5 11.7414ZM13.0625 9.05142V7H10.4411L13.0625 9.05142ZM6.81966 7L13.0625 11.8854V17H7.28125C7.20312 17 7.125 16.9219 7.125 16.8438V12.625H11.5V10.75H5.875V7H6.81966ZM14.9375 13.3527L19.5983 17H14.9375V13.3527ZM8.41406 3.5625C8.41406 4.46094 9.11719 5.125 9.97656 5.125H13.375L13.2969 5.00781C11.4609 2.3125 10.8359 2 9.97656 2C9.11719 2 8.41406 2.70312 8.41406 3.5625ZM18.0625 2C17.2031 2 16.5781 2.3125 14.7422 5.00781L14.6641 5.125H18.0625C18.9219 5.125 19.625 4.46094 19.625 3.5625C19.625 2.70312 18.9219 2 18.0625 2Z",
    fill: "#36424E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgNoReward);
export default __webpack_public_path__ + "static/media/img-no_reward.8381cdae250b3d94db3a3ee46e47458f.svg";
export { ForwardRef as ReactComponent };